import { AdvancedSearchConfig } from "../forms/advanced-search/advanced-search-fields-def";
import { ColumnFormatted } from "./general";

export const photographiesColumns: ColumnFormatted[] = [
  {
    type: "string",
    key: "photosDescriptionNumeroEnregistrement",
    visible: true,
  },
  { type: "image", key: "vignette", visible: true },
  { type: "string", key: "photosDescriptionType", visible: true },
  { type: "string", key: "photosDescriptionClassement", visible: true },
  { type: "string", key: "photosDescriptionRangement" },
  { type: "string", key: "photosDescriptionLocalisation", visible: true },
  { type: "string", key: "photosDescriptionNombreExemplairesArchives" },
  { type: "richtext", key: "photosDescriptionTitre", visible: true },
  { type: "string", key: "photosDescriptionDate", visible: true },
  { type: "string", key: "photosDescriptionTheme" },
  { type: "string", key: "photosDescriptionTechnique" },
  { type: "string", key: "photosDescriptionLieuDeCreation" },
  { type: "string", key: "photosDescriptionPhotographe" },
  { type: "string", key: "photosDescriptionCopyright" },
  { type: "boolean", key: "photosDescriptionCopies" },
  { type: "string", key: "photosDescriptionPhoto" },
  { type: "string", key: "photosDescriptionPhotoDos" },
  { type: "string", key: "photosDescriptionPhotoVariante" },
  { type: "string", key: "photosDescriptionPhotoVarianteLegende" },
  { type: "string", key: "photosDescriptionLegendeRedigee" },
  { type: "richtext", key: "photosDescriptionNotes" },
  { type: "string", key: "photosDescriptionPersonnes" },
  { type: "boolean", key: "photosFichierPhotoBasseDefinitionUniquement" },
  { type: "boolean", key: "photosFichierPhotoScanAFaire" },
  { type: "boolean", key: "photosFichierPhotoOkWeb" },
  { type: "boolean", key: "photosFichierPhotoHdOk" },
  { type: "boolean", key: "photosAcquisitionDocumentAAcquerir" },
  { type: "boolean", key: "photosAcquisitionDocumentAcquis" },
  { type: "string", key: "photosAcquisitionDateAcquisition" },
  { type: "string", key: "photosAcquisitionVendeur" },
  { type: "richtext", key: "photosAcquisitionNotes" },
  { type: "string", key: "photosMouvementsDepot" },
  { type: "richtext", key: "photosMouvementsNotesDepot" },
  { type: "string", key: "photosMouvementsValeurAssurance" },
  { type: "status", key: "photosPublicationStatus", visible: true },
  { type: "richtext", key: "sources" },
];

export const photographiesAdvancedSearchConfig: AdvancedSearchConfig = [
  {
    type: "group",
    label: "photographiesDescription",
    fields: [
      { type: "string", key: "photosDescriptionNumeroEnregistrement" },
      { type: "boolean", key: "photosDescriptionCopies" },
      { type: "string", key: "photosDescriptionType" },
      { type: "string", key: "photosDescriptionClassement" },
      { type: "string", key: "photosDescriptionRangement" },
      { type: "string", key: "photosDescriptionLocalisation" },
      { type: "string", key: "photosDescriptionNombreExemplairesArchives" },
      { type: "string", key: "photosDescriptionTitre" },
      { type: "string", key: "photosDescriptionDate" },
      { type: "string", key: "photosDescriptionTheme" },
      { type: "string", key: "photosDescriptionDimensions" },
      { type: "string", key: "photosDescriptionTechnique" },
      { type: "string", key: "photosDescriptionLieuDeCreation" },
      { type: "string", key: "photosDescriptionPhotographe" },
      { type: "string", key: "photosDescriptionCopyright" },
      { type: "string", key: "photosDescriptionLegendeRedigee" },
      { type: "string", key: "photosDescriptionNotes" },
      { type: "boolean", key: "photosFichierPhotoBasseDefinitionUniquement" },
      { type: "boolean", key: "photosFichierPhotoScanAFaire" },
      { type: "boolean", key: "photosFichierPhotoOkWeb" },
      { type: "boolean", key: "photosFichierPhotoHdOk" },
      { type: "boolean", key: "photosAcquisitionDocumentAAcquerir" },
      { type: "boolean", key: "photosAcquisitionDocumentAcquis" },
      { type: "string", key: "photosAcquisitionDateAcquisition" },
      { type: "string", key: "photosAcquisitionVendeur" },
      { type: "string", key: "photosAcquisitionNotes" },
      { type: "string", key: "photosMouvementsDepot" },
      { type: "string", key: "photosMouvementsNotesDepot" },
      { type: "string", key: "photosMouvementsValeurAssurance" },
    ],
  },
  {
    type: "group",
    label: "sources",
    fields: [{ type: "string", key: "sources" }],
  },
];
